// third-party
import { combineReducers } from 'redux';

// project import
import aiChat from './aiChat';
import apiStatus from './apiStatus';
import breadcrumb from './breadcrumb';
import buttons from './buttons';
import exports from './exports';
import invoices from './invoices';
import menu from './menu';
import notFound from './notFound';
import subDrawer from './subdrawer';
import temporaryDrawer from './temporaryDrawer';
import timecard from './timecard';

import { portalAPI } from 'store/api/portalAPI';

// ==============================|| COMBINE REDUCERS ||============================== //

const reducers = combineReducers({
    apiStatus,
    exports,
    menu,
    subDrawer,
    temporaryDrawer,
    timecard,
    buttons,
    invoices,
    notFound,
    breadcrumb,
    aiChat,
    [portalAPI.reducerPath]: portalAPI.reducer,
});

export type RootState = ReturnType<typeof reducers>;

export default reducers;
